<template>
    <div>
        <h1>Loans with amortization details</h1>
        <v-btn
                style="float:right"
                dark
                color="pink"
                @click="addLender('Lender Name '+ (loanOptions.length + 1))"
        >
            Add a Loan Option <v-icon>mdi-plus</v-icon>
        </v-btn>

        <br />
        <br />
        <v-tabs
                v-model="tab"
                background-color="grey accent-1"
                class="elevation-2"
                dark
                next-icon="mdi-arrow-right-bold-box-outline"
                prev-icon="mdi-arrow-left-bold-box-outline"
                show-arrows
        >

            <v-tabs-slider></v-tabs-slider>

            <v-tab
                    v-for="(lender, i) in loanOptions"
                    :key="i"
                    :href="`#tab-${i}`"
            >
                <v-text-field
                        class="centered-input"
                        v-model="loanOptions[i].name"
                ></v-text-field>

                <v-icon @click="removeLender(i)">mdi-close</v-icon>
            </v-tab>

            <v-tab-item
                    v-for="(lender, i) in loanOptions"
                    :key="i"
                    :value="'tab-' + i"
            >
                <v-card
                        flat
                        tile
                >
                    <HelloWorld :data="loanOptions[i]"/>
                </v-card>
            </v-tab-item>
        </v-tabs>

        <v-col class="mb-4" cols="12">
        <p class="subheading font-weight-regular">
            All calculation in the table and on the graph are rounded to the nearest integer to look less crowded, so there's a small difference comparing to the real calculation, don't use these numbers for any legal documents.
        </p>
    </v-col>


        <v-dialog
                v-model="dialog"
                max-width="590"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-fab-transition>
                    <v-btn
                            color="pink"
                            dark
                            fixed
                            bottom
                            right
                            fab
                            v-bind="attrs"
                            v-on="on"
                    >
                        <v-icon>mdi-share-variant</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <v-card>
              <h3 style="color: red">This feature is disabled because of the lack of traffic, email me at (deyikong at yahoo.com) if you'd like this feature enabled.</h3>
                <v-card-title class="headline">
                    Share this comparison
                </v-card-title>
                <v-card-text>
                    A URL with this exact comparison will be sent to the following email address.
                    <v-text-field
                                  disabled
                                  label="Email"
                                  v-model="shareEmail"
                    >
                    </v-text-field>
                    <v-textarea
                        disabled
                        v-model="notes"
                        name="input-7-1"
                        label="Notes"
                        placeholder="Add some notes here if you are sharing it to others"
                        hint="notes to be attached in the email"
                ></v-textarea>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="dialog = false"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        disabled
                        color="green darken-1"
                            text
                            @click="saveLoans"
                    >
                        Share to email
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog
                v-model="successDialog"
                max-width="590"
        >
            <v-card>
                <v-card-title class="headline">
                    Email Sent
                </v-card-title>
                <v-card-text style="text-align: center">
                    <p>An email with the following URL is sent to email {{shareEmail}}.</p>
                    <br >
                    <img class="thumbnail img-responsive"
                         :src="qrUrl"
                         width="300px" height="300px">
                    <v-spacer></v-spacer>
                    <h3 ref="url"><a :href="'https://'+shareUrl">{{shareUrl}}</a></h3>
                    <v-btn
                            @click="copy"
                    >Copy</v-btn>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="green darken-1"
                            text
                            @click="successDialog = false"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-snackbar
                v-model="showSnack"
        >
            Copied "{{this.shareUrl}}"
        </v-snackbar>

        <Compare :loan-options="loanOptions"></Compare>

<br>
<br>
<br>
<br>
<br>
<br>

        <v-footer
                fixed
                :padless="true"
        >
            <v-card
                    flat
                    tile
                    width="100%"
                    class="lighten-1 text-center"
            >
                <v-card-text>
                    If you like this little tool, you can donate some dollars to keep this site up and running. Venmo @DeyiKong
                </v-card-text>

                <v-divider></v-divider>

                <v-card-text>
                    {{ new Date().getFullYear() }} — <strong> Made with ❤️ by <a href="https://github.com/deyikong">Deyi Kong</a></strong>
                </v-card-text>
            </v-card>
        </v-footer>
    </div>
</template>

<script>
    import HelloWorld from '../components/HelloWorld';
    import Compare from '../components/Compare';
    import {mapMutations, mapState} from "vuex";
    import Loan from "../loan";

    export default {
        name: 'Home',
        metaInfo: {
            title: 'Mortgage Comparison',
            htmlAttrs: {
                lang: 'en',
                amp: true
            },
            meta: [
                { charset: 'utf-8' },
                { name: 'description', content: 'Compare different mortgage loans by showing you detailed amortizations, break even point and how much interest and principle you spend every month and every year.' },
                { name: 'author', content: 'Deyi Kong' },
                { name: 'keywords', content: 'mortgage comparison, mortgage rate comparison, mortgage comparison calculator, mortgage amortization, mortgage amortization calculator, mortgage calculator amortization' },
            ],
        },
        components: {
            HelloWorld,
            Compare
        },
        props: {
          id: {
              type: String,
              required: false
          }
        },
        data: () => ({
            menu: false,
            dialog: false,
            successDialog: false,
            newLenderName: '',
            tab: 'tab-0',
            loanOptions: [],
            code: '',
            shareEmail: '',
            notes: '',
            showSnack: false,
        }),
        created() {
            if (this.id) {
                this.$http.get('/profiles/' + this.id)
                    .then(res => {
                        this.loanOptions = JSON.parse(res.data.data);
                    })
            } else {
                this.addLender("Lender Name 1");
                let self = this
                setTimeout(function() {
                    self.addLender("Lender Name 2");
                }, 500);
            }
        },
        computed: {
            ...mapState(['defaultListingPrice','propertyTax', 'homeInsurance', 'hoa']),
            shareUrl: function () {
                return location.host
                    + '/' +this.code
            },
            qrUrl: function () {
                return 'http://chart.apis.google.com/chart?cht=qr&chs=300x300&chld=L|0&chl='
                    + this.shareUrl;
            },
            localPropertyTax: {
                set: function (val) {
                    this.setPropertyTax(val);
                },
                get: function () {
                    return this.propertyTax;
                }
            },
            localHomeInsurance: {
                set: function (val) {
                    this.setHomeInsurance(val);
                },
                get: function () {
                    return this.homeInsurance;
                }
            },
            localHoa: {
                set: function (val) {
                    this.setHoa(val);
                },
                get: function () {
                    return this.hoa;
                }
            },
        },
        methods: {
            ...mapMutations(["setPropertyTax", "setHomeInsurance", "setHoa"]),
            saveLoans: function() {
                this.$http.post('/profiles', {
                    data: JSON.stringify(this.loanOptions),
                    email: this.shareEmail,
                    notes: this.notes
                })
                    .then(res => {
                        if (res.data.code ) {
                            this.code = res.data.code;
                            this.successDialog = true;
                        } else {
                            console.log('failed')
                        }
                        this.dialog = false;
                    })
            },
            copy: function () {
                this.selectText(this.$refs.url); // e.g. <div ref="text">
                document.execCommand("copy");
                this.showSnack = true
            },
            selectText(element) {
                var range;
                if (document.selection) {
                    // IE
                    range = document.body.createTextRange();
                    range.moveToElementText(element);
                    range.select();
                } else if (window.getSelection) {
                    range = document.createRange();
                    range.selectNode(element);
                    window.getSelection().removeAllRanges();
                    window.getSelection().addRange(range);
                }
            },
            addLender: function(name) {
                // let localName = "Loan "+this.loanOptions.length;
                // if (name){
                //     localName = name;
                // }
                var newLender = new Loan(this.loanOptions.length, name, this.defaultListingPrice);
                this.loanOptions.push(newLender);
                this.tab = 'tab-'+(this.loanOptions.length-1);
                this.newLenderName = '';
            },
            removeLender: function(i) {
                this.loanOptions.splice(i,1);
            }
        }
    };
</script>